import { MDSSkeleton } from "@/mds/components/loading/skeleton";

import styled from "@emotion/styled";

export const IntegrationsLoader = () => {
  return (
    <SkeletonWrapper>
      <ContentSkeleton>
        <SectionSkeleton>
          <MDSSkeleton height={16} width={220} />
          <BlockSkeleton>
            <MDSSkeleton height={60} width={60} />
            <MDSSkeleton height={60} width={600} />
          </BlockSkeleton>
          <BlockSkeleton>
            <MDSSkeleton height={60} width={60} />
            <MDSSkeleton height={60} width={600} />
          </BlockSkeleton>
        </SectionSkeleton>
      </ContentSkeleton>
    </SkeletonWrapper>
  );
};

const SkeletonWrapper = styled.div({
  display: "flex",
  flexDirection: "column",
  margin: `22px 0`,
});

const ContentSkeleton = styled.div({
  display: "flex",
  flexDirection: "column",
  gap: "32px",
});

const SectionSkeleton = styled.div({
  display: "flex",
  flexDirection: "column",
  gap: "16px",
  alignItems: "flex-start",
});

const BlockSkeleton = styled.div({
  display: "flex",
  flexDirection: "row",
  gap: "16px",
});
